export { FinancialPage as default } from '@/components/pages/Ir/Financial'
